import {
  TreemapModule,
  createTreemapServices
} from "./chunk-VX7I4HLL.mjs";
import "./chunk-YAJQ3QCK.mjs";
export {
  TreemapModule,
  createTreemapServices
};
